import gql from "graphql-tag";

export default gql`
  mutation CheckoutUrl($product: CheckoutProduct!, $coupon: ID, $parameters: CheckoutParametersInput) {
    checkoutUrl(product: $product, coupon: $coupon, parameters: $parameters)
  }
`;
